// Capabilities that are available in native app
enum NativeCapability {
  FlpLoginButton = 'flpLoginButton'
}

export default NativeCapability;
